import React, {  useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CommonInput, CommonModal, } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createGpsIntrigationApi } from '_services';

const formObj = {
    company_id: StorageService.getCompanyId(),
    name: '',
    type:"",
    access_token:""
}

const AddGpsModal = (props) => {

    const { isOpen, closeModal, nextModal } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props?.isOpen?.name) {
            setFormValue({ ...formValue, name: props?.isOpen?.name })
        }

    }, [props])

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addGpsIntrigationSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {

        const payload = {
            company_id: StorageService.getCompanyId(),
            name:formValue?.name,
            type:props?.modalTitle=="Integrate Fleetx"?"fleetx":"wheelseye",
            payload:{
                access_token:formValue?.access_token
            }
        }

        try {
            const res = await createGpsIntrigationApi(payload);
            if (res?.responseCode === 200) {
                setFormValue(formObj);
                setLoading(false);
                toast.success(res?.responseMessage);
                closeModal(false);
            } else {
                setLoading(false);
                toast.error(res?.responseMessage);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, errorSchema.addGpsIntrigationSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction();
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen) {
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
            }))
        }
    }, [isOpen])

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: props?.isOpen?.view || loading,
        onSubmit: handleClick,
    }

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body mt-2'>
                    <div className='colFlx'>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label=' Name * '
                                placeholder=' Name * '
                                name='name'
                                value={formValue.name}
                                focus={!!(typeof formError === "object" && formError?.name)}
                                error={!!(typeof formError === "object") ? formError?.name : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                                disabled={props?.isOpen?.view}
                            />
                             
                        </div>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label='Token * '
                                placeholder='Token * '
                                name='access_token'
                                value={formValue.access_token}
                                focus={!!(typeof formError === "object" && formError?.access_token)}
                                error={!!(typeof formError === "object") ? formError?.access_token : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                                disabled={props?.isOpen?.view}
                            />
                             
                        </div>
                    </div>
                </div>
            </CommonModal>
            {/* <div className='offBack_drop'></div> */}

        </div>
    )
}

export default AddGpsModal
